// Centralized logging utility that respects development environment
export const logger = {
  log: (message: string, data?: any) => {
    if (process.env.NODE_ENV === "development") {
      if (data) {
        console.log(message, data);
      } else {
        console.log(message);
      }
    }
  },

  // Use this for expected errors (API errors, etc.) - won't trigger error overlay
  error: (message: string, error?: any) => {
    if (process.env.NODE_ENV === "development") {
      if (error) {
        console.warn(`[ERROR] ${message}`, error);
      } else {
        console.warn(`[ERROR] ${message}`);
      }
    }
  },

  // Use this for critical unexpected errors - WILL trigger error overlay
  criticalError: (message: string, error?: any) => {
    if (process.env.NODE_ENV === "development") {
      if (error) {
        console.error(message, error);
      } else {
        console.error(message);
      }
    }
  },

  warn: (message: string, data?: any) => {
    if (process.env.NODE_ENV === "development") {
      if (data) {
        console.warn(message, data);
      } else {
        console.warn(message);
      }
    }
  },

  info: (message: string, data?: any) => {
    if (process.env.NODE_ENV === "development") {
      if (data) {
        console.info(message, data);
      } else {
        console.info(message);
      }
    }
  },

  debug: (message: string, data?: any) => {
    if (process.env.NODE_ENV === "development") {
      if (data) {
        console.debug(message, data);
      } else {
        console.debug(message);
      }
    }
  },
};
